import authSagas from "./auth";
import userManagementSaga from "./userManagement";
import settingsSagas from "./settings";
import alertsSaga from "./alerts";
import accountSagas from "./account";
import loanSagas from "./loan";

const sagas = [
  authSagas,
  userManagementSaga,
  settingsSagas,
  alertsSaga,
  accountSagas,
  loanSagas
]

const registerSagas = (middleware) => {
  sagas.forEach((saga) => {
    middleware.run(saga)
  })
}

export default registerSagas;